// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__16ObR","col":"Table_col__2gW2W","fulfillmentStatus":"Table_fulfillmentStatus__3UYIZ","emailCol":"Table_emailCol__26ynh"};